import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-hot-toast";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import ServiceOffersListPage from "./components/ServiceOffersListPage";
import { apiCall } from "utils/apiClient";

const ServiceOffers = () => {
  // FIX: reloadKey must change to trigger child refetch
  const [reloadKey, setReloadKey] = useState(0);

  const navigate = useNavigate();

  const handleDeleteOffer = async (offer) => {
    const offerId = String(offer?.id ?? "");

    if (!offerId) {
      toast.error("Invalid offer id");
      return false;
    }

    let result;
    try {
      result = await apiCall({
        endpoint: `admin/service-offers/delete/${offerId}`,
        method: "DELETE",
      });
    } catch (error) {
      toast.error("Failed to delete offer");
      return false;
    }

    const isDeleteSuccess =
      result?.status === true ||
      Number(result?.status) === 200 ||
      Number(result?.status) === 201 ||
      Number(result?.status) === 204 ||
      Number(result?.code) === 200 ||
      Number(result?.code) === 201 ||
      Number(result?.code) === 204 ||
      result?.data === true ||
      result?.data?.success === true ||
      result?.success === true;

    if (isDeleteSuccess) {
      toast.success("Offer deleted successfully");

      // CRITICAL: trigger refetch
      setReloadKey((prev) => prev + 1);

      return true;
    }

    toast.error(result?.message || "Failed to delete offer");
    return false;
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <div className="px-6 py-6">
        <div className="mb-4">
          <h2 className="text-xl font-bold text-gray-900">
            Service Offers
          </h2>
        </div>

        <ServiceOffersListPage
          reloadKey={reloadKey}
          onAdd={() => navigate("/add-service-offer")}
          onEdit={(offer) =>
            navigate("/update-service-offer", { state: { offer } })
          }
          onDelete={handleDeleteOffer}
        />
      </div>
    </DashboardLayout>
  );
};

export default ServiceOffers;
